import styles from '../components/reminderEngineShared.module.css';

export const getReminderStatusClass = (status: string) => {
  const normalized = status.toLowerCase();
  if (normalized === 'pending' || normalized === 'processing') return styles.statusPending;
  if (normalized === 'completed' || normalized === 'partiallycompleted') return styles.statusCompleted;
  if (normalized === 'failed') return styles.statusFailed;
  if (normalized === 'cancelled' || normalized === 'skipped') return styles.statusCancelled;
  if (normalized === 'active') return styles.statusActive;
  if (normalized === 'draft') return styles.statusDraft;
  if (normalized === 'archived') return styles.statusArchived;
  return styles.statusBadge;
};
